import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Dropdown } from '../Dropdown/Dropdown.js';
import { MultipleSelectorStateActions, } from '../DropdownSelector/MultipleSelectorReducer.js';
import { Tag } from '../Tag/Tag.js';
import { TagInput } from '../TagInput/TagInput.js';
export function TagInputSelector({ clearLabel, itemTag, state, dispatch, }) {
    const { items, selectedIds, containsRemovableSelection } = state;
    const selectedItems = items.filter(({ id }) => selectedIds.includes(id));
    const handleItemClick = useCallback(({ id }) => dispatch(new MultipleSelectorStateActions.ToggleItem(id)), [dispatch]);
    return (_jsx(Dropdown, { items: items, activeItemIds: selectedIds, isContentItem: (item) => item.removable === false, renderItem: (item) => {
            const { tag, color, transform } = itemTag(item);
            return (_jsx(Tag, { color: color, transform: transform, children: tag }, item.id));
        }, renderTrigger: (ref, onOpenDropDown) => {
            return (_jsxs(TagInput, { ref: ref, onClick: onOpenDropDown, children: [selectedItems.map((item) => {
                        const { tag, color, transform } = itemTag(item);
                        return (_jsxs(Tag, { color: color, transform: transform, children: [tag, item.removable !== false ? (_jsx(Tag.Remove, { onClick: () => dispatch(new MultipleSelectorStateActions.ToggleItem(item.id)) })) : null] }, item.id));
                    }), containsRemovableSelection ? (_jsx(Tag.Clear, { onClick: () => dispatch(new MultipleSelectorStateActions.ClearSelection()), children: clearLabel })) : null] }));
        }, onItemClick: handleItemClick }));
}
//# sourceMappingURL=TagInputSelector.js.map